import React from 'react';
import KYPPDFGenerator from '../components/common/KYPPDFGenerator';

const TestKYPPDF = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f8f9fa',
      padding: '20px' 
    }}>
      <KYPPDFGenerator />
    </div>
  );
};

export default TestKYPPDF;
